import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary.js';
import { List as Listed, Loader } from 'semantic-ui-react';
import Input from '../../Adapters/UI/Input/Input';
import { Map, List, fromJS } from 'immutable';
import axios from 'axios';
import './searchbrand.css';

const ROOT_URL = process.env.REACT_APP_API_ROOT_URL;

const ThemeContext = React.createContext('search');

class ThemeProvider extends PureComponent {
    
  state = {
    searchLoading: false,
    data: Map({
      search: '',
      brands: [],
    }),
  };
  
  handleChange = event => {
  
    const searchTerm = event.target.value;
    this.handleSearch(searchTerm);
    this.setState(({data}) => ({
      data: data.update('search', search => searchTerm),
    }));
    this.setState({searchLoading: true});
  }
  
  handleSearch = value => {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('jwt');
    const request = axios.get(`${ROOT_URL}/brands?name=${value}`);
    request
      .then(res => {
        this.setState(({data}) => ({
          data: data.update('brands', brands => res.data.data),
        }))
        this.setState({searchLoading: false})
      })
      .catch((err) => {});
  }
  
  onSubmit(event) {
    event.preventDefault();
  }

  render() {
    const data = this.state.data.toJS();
    return (
      <ThemeContext.Provider value={data}>
        <div className='form-container'>
          <ErrorBoundary componentName="SearchBrand">
            <div className='button-and-search'>
                <Link to='/createBrand'><button>Create Brand</button></Link>
              </div>
              <div className='button-and-search'>or</div>
              <div className='button-and-search'>
                <Input
                  name='searchBrand'
                  placeholder='Search Brands'
                  onChange={this.handleChange}
                  icon='search'
                  onSubmit={this.onSubmit}
                  value={data.search}
                  autoFocus
                />
              </div>
            {this.state.searchLoading && <Loader active inline='centered' />}
            {this.props.children}
          </ErrorBoundary>
        </div>
      </ThemeContext.Provider>
    );
  }
}

const SearchBrand = () => (
  <div className='searchlist-container'>
    <ThemeProvider>
      <ThemeContext.Consumer>
        {data => (
          <Listed divided verticalAlign='middle'>
            {data.search
              ? data.brands.map(brand => (
                <div key={brand.id}>
                  <Listed.Item>
                    <Listed.Content floated='right'>
                      <Link to={`/brandLanding/${brand.id}`}><button>Go</button></Link>
                    </Listed.Content>
                    <Listed.Content>
                      <Link to={`/brandLanding/${brand.id}`}>{brand.name} </Link>
                    </Listed.Content>
                  </Listed.Item>
                </div>
              ))
              : null}
          </Listed>
        )}
      </ThemeContext.Consumer>
    </ThemeProvider>
  </div>
);

export default SearchBrand;



// WEBPACK FOOTER //
// ./src/pages/SearchBrand/SearchBrand.js